import { vendey, execute, request, unwrap, csvRows } from './api.js';
import { COMPANY } from './config.js';
import { logService } from './logs.js';
const schemas = {
  warehouses: { ids: ['NCODALMACEN', 'NCODIGO', 'CODIGO'], names: ['CALAMCENDESC', 'CALMACENDESC', 'CDESALMACEN', 'CNOMBREALMACEN', 'CDESCRIPCION', 'DESCRIPCION'] },
  prices: { ids: ['NCODLISTAPRECIO', 'NCODIGO', 'CODIGO'], names: ['CNOMLISTAPRECIO', 'CLISTAPRECIODESC', 'CDESCRIPCION', 'DESCRIPCION'] },
  families: { ids: ['NCODFAMILIA', 'NCODIGO', 'CODIGO'], names: ['CFAMILIADESC', 'CNOMFAMILIA', 'CDESCRIPCION', 'DESCRIPCION'] }
};
export function catalogOptions(value, type) {
  const schema = schemas[type]; if (!schema) throw new Error('Catálogo no reconocido.');
  const rows = csvRows(unwrap(value)); const seen = new Set();
  return rows.flatMap(row => {
    const entries = Object.entries(row); const values = entries.map(([, value]) => value);
    const find = names => entries.find(([key]) => names.includes(key.trim().toUpperCase()))?.[1];
    if (type === 'prices' && entries.some(([key]) => key.trim().toUpperCase() === 'NCODPRODUCTO') && find(schema.names) == null) return [];
    const id = String(find(schema.ids) ?? row.id ?? values[0] ?? '').trim();
    const name = String(find(schema.names) ?? row.name ?? values[1] ?? '').trim();
    if (!id || !name || seen.has(id)) return [];
    seen.add(id); return [{ id, name }];
  });
}
export async function loadInventoryCatalogs() {
  const result = await Promise.allSettled([
    vendey('spINV_ALMACENLISTACSVWEB', '1|1|'),
    execute('sputilitarios', '{|caccion|:|listarprecios|}'),
    request('Vendey/ListarFamiliasnew', { token: COMPANY }).then(unwrap)
  ]);
  const value = { warehouses: [], prices: [], families: [], errors: [], notes: [] };
  ['warehouses', 'prices', 'families'].forEach((type, index) => {
    const entry = result[index];
    if (entry.status === 'fulfilled') {
      try {
        value[type] = catalogOptions(type === 'prices' ? entry.value?.vnt_listaprecio ?? entry.value : entry.value, type);
        if (!value[type].length) throw new Error('El catálogo llegó vacío.');
      } catch (error) { value.errors.push(`${type === 'prices' ? 'Listas de precio' : type === 'families' ? 'Familias' : 'Almacenes'}: ${error.message}`); }
    } else value.errors.push(`${type === 'prices' ? 'Listas de precio' : type === 'families' ? 'Familias' : 'Almacenes'}: ${entry.reason.message}`);
  });
  if (!value.prices.length) {
    try {
      // La consulta que www usa para el catálogo puede devolver solo detalles de precio.
      const data = unwrap(await request('Vendey/ListasDePrecionew', { token: COMPANY, NCODFAMILIA: 0 }));
      value.prices = catalogOptions(data, 'prices');
      if (!value.prices.length) {
        const ids = [...new Set(csvRows(data).map(row => String(row.NCODLISTAPRECIO ?? '').trim()).filter(id => Number(id) > 0))];
        value.prices = ids.map(id => ({ id, name: `Lista de precio ${id}` }));
        if (ids.length) value.notes.push('Las listas vigentes se muestran por código: el servicio no devolvió sus nombres.');
      }
      if (value.prices.length) {
        value.errors.filter(error => error.startsWith('Listas de precio:')).forEach(error => logService('Catálogo de listas de precio', error));
        value.errors = value.errors.filter(error => !error.startsWith('Listas de precio:'));
      }
    } catch (error) { logService('Consulta de listas de precio', error.message); }
  }
  return value;
}
